import action from './action';
import address from './address';
import analytics from './analytics';
import auth from './auth';
import cascade from './cascade';
import chat from './chat';
import common from './common';
import constructionCard from './constructionCard';
import customers from './customers';
import date from './date';
import deals from './deals';
import deliveries from './deliveries';
import error from './error';
import financialStatement from './financialStatement';
import map from './map';
import organizer from './organizer';
import promises from './promises';
import reports from './reports';
import unit from './unit';
import products from './products';

const russianMessages = {
  ...action,
  ...address,
  ...analytics,
  ...auth,
  ...cascade,
  ...chat,
  ...common,
  ...constructionCard,
  ...customers,
  ...date,
  ...deals,
  ...deliveries,
  ...error,
  ...financialStatement,
  ...map,
  ...organizer,
  ...promises,
  ...reports,
  ...unit,
  ...products,
};

export default russianMessages;
